import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RedirectSpinner from "../components/RedirectSpinner";
import { resolveCode, FALLBACK_URL } from "../services/shortlink";

/**
 * /s/:code — ตัวพาไปปลายทางฝั่ง client
 *
 * ปกติคำขอ /s/** จะถูก Firebase Hosting ส่งตรงไป Cloud Run แล้วได้ HTTP 302 เลย
 * (ดู BE/deploy/firebase-rewrite.md) หน้านี้คือทางสำรองสำหรับตอนที่ยังไม่ได้ตั้ง rewrite
 * หรือตั้งไว้แล้วแต่คำขอวิ่งมาถึง SPA ด้วยเหตุใดก็ตาม
 *
 * กฎข้อ 2 บังคับว่าห้ามมีทางตัน ทุกเส้นทางที่จบลงต้องพาไปสักที่เสมอ
 * ต่อ API ไม่ได้ ก็ยังต้องไป fallback ไม่ใช่ค้างหน้าขาว
 */
const ShortLinkResolve = () => {
  const { code } = useParams();
  const [stalled, setStalled] = useState(false);

  useEffect(() => {
    let cancelled = false;

    // ถ้าเกิน 6 วินาทีแล้วยังไม่ไปไหน แสดงทางออกให้ผู้ใช้กดเอง
    const stallTimer = setTimeout(() => {
      if (!cancelled) setStalled(true);
    }, 6000);

    async function go() {
      const search = window.location.search || "";
      const result = await resolveCode(code, search);
      if (cancelled) return;

      const target = (result && result.target) || FALLBACK_URL;

      if (window.gtag) {
        window.gtag("event", "short_link_click", {
          short_code: code,
          outcome: (result && result.outcome) || "unknown",
        });
      }

      // replace ไม่ใช่ assign เพื่อไม่ให้ปุ่ม back ของเบราว์เซอร์วนกลับมาที่หน้านี้อีก
      window.location.replace(target);
    }

    go();
    return () => {
      cancelled = true;
      clearTimeout(stallTimer);
    };
  }, [code]);

  if (stalled) {
    return (
      <div style={{ padding: 32, textAlign: "center", fontFamily: "Prompt, sans-serif" }}>
        <p style={{ marginBottom: 16 }}>กำลังพาไปยังปลายทาง ใช้เวลานานกว่าปกติ</p>
        <a href={FALLBACK_URL} style={{ color: "#93d701", fontWeight: 600 }}>
          ไปหน้าหลัก Big C
        </a>
      </div>
    );
  }

  return <RedirectSpinner />;
};

export default ShortLinkResolve;
